import React from "react";
import { useLang } from "@/context/LanguageContext";

// Visual service card with image background; description reveals on hover.
const ServiceCard = ({ item, index, accent = "#edaa51", testId }) => {
  const { t } = useLang();
  return (
    <div
      data-testid={testId}
      className="group relative overflow-hidden rounded-2xl min-h-[360px] flex flex-col justify-end border border-white/10 hover:border-white/25 transition-colors"
    >
      <img
        src={item.image}
        alt=""
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-70 group-hover:scale-110 transition-all duration-[900ms] ease-out"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/65 to-ink/20" />
      <div className="absolute inset-x-0 bottom-0 h-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `linear-gradient(to top, ${accent}26, transparent)` }} />
      <div className="relative z-10 p-7">
        <span className="font-display text-5xl font-black leading-none" style={{ color: accent }}>
          {String(index + 1).padStart(2, "0")}
        </span>
        <h3 className="mt-4 font-display text-2xl font-bold uppercase text-white leading-tight">{t(item.title)}</h3>
        <p className="mt-3 text-white/70 text-sm font-body leading-relaxed max-h-0 opacity-0 group-hover:max-h-48 group-hover:opacity-100 transition-all duration-500 overflow-hidden">
          {t(item.desc)}
        </p>
      </div>
    </div>
  );
};

export default ServiceCard;
